export enum ROLE_ID {
	PATIENT = 'PATIENT',
	PROVIDER = 'PROVIDER',
	ADMINISTRATOR = 'ADMINISTRATOR',
	MHIC = 'MHIC',
}
